import {
  SpotLengthType,
  StageOnePoint,
  StageTwoPath,
  StageTwoRow
} from './linear-ml-diagnostics-constants';

const TICK_COUNT = 8;

// Evenly spaced x-axis ticks that always end on the last data point.
export const computeTicks = (values: StageOnePoint[]): number[] => {
  if (values.length === 0) return [];
  const min = values[0].time;
  const max = values[values.length - 1].time;
  const step = Math.round((max - min) / (TICK_COUNT - 1));
  return [...Array.from({ length: TICK_COUNT - 1 }, (_, i) => min + step * i), max];
};

export const getStageTwoValue = (
  row: StageTwoRow,
  length: SpotLengthType,
  path: StageTwoPath
): number | null | undefined => {
  const entry = row[length];
  if (!entry) return undefined;
  return path[0] === 'stageTwoByCreative' ? entry.stageTwoByCreative?.[path[1]] : entry[path[0]];
};
